import { setCaptchaResponse } from '../actions/captchaActions';
import ReCAPTCHA from 'react-google-recaptcha';
import React, { Component } from 'react';
import { ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import Modal from './Modal/Modal';
import config from '../config';

/**
 * CaptchaModal - CAPTCHA verification component
 * 
 * This component uses Cloudflare Turnstile with reCAPTCHA compatibility mode.
 * The Turnstile script is loaded with ?compat=recaptcha parameter in index.html,
 * which allows us to use the react-google-recaptcha library without any code changes.
 * 
 * Simply replace the siteKey in config with your Turnstile sitekey.
 */

class CaptchaModal extends Component {
    // Use instance variable for synchronous check (not affected by setState async behavior)
    hasProcessed = false;
    recaptchaRef = React.createRef();

    componentDidUpdate(prevProps) {
        // ONLY reset when modal opens (not when closes) to prevent race condition
        if (!prevProps.isOpen && this.props.isOpen) {
            console.log('[CaptchaModal] Modal opened, resetting hasProcessed flag');
            this.hasProcessed = false;
            // Reset the ReCAPTCHA widget when modal reopens
            if (this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
        }
    }

    handleSuccess = response => {
        // Prevent duplicate calls from ReCAPTCHA onChange firing multiple times
        if (this.hasProcessed) {
            console.warn('[CaptchaModal] Already processed, blocking duplicate');
            return;
        }
        this.hasProcessed = true;

        const { setCaptchaResponse, onSuccess } = this.props;
        setCaptchaResponse(response);
        onSuccess();
    };

    render() {
        const { isOpen, toggle } = this.props;

        return (
            <Modal isOpen={isOpen} toggle={toggle}>
                <ModalBody className="text-center">
                    <ReCAPTCHA
                        ref={this.recaptchaRef}
                        className="d-inline-block mt-2"
                        sitekey={config.turnstile.siteKey}
                        onChange={this.handleSuccess}
                    />
                </ModalBody>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    setCaptchaResponse,
};

export default connect(null, mapDispatchToProps)(CaptchaModal);
